import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import IconButton from '@mui/material/IconButton';
import { useCallback, useMemo } from 'react';
import { DIRECT_DEALS_LIST_VIEW, type DirectDealsListView } from '../../utils/context/types.ts';

type ViewIconButtonProps = {
  currentViewType: DirectDealsListView;
  viewType: DirectDealsListView;
  onViewTypeChange: (type: DirectDealsListView) => void;
};

const viewTypeIcons = {
  [DIRECT_DEALS_LIST_VIEW.TABULAR]: ViewListOutlinedIcon,
  [DIRECT_DEALS_LIST_VIEW.TILE]: ViewModuleOutlinedIcon,
};

export const ViewIconButton = ({ currentViewType, viewType, onViewTypeChange }: ViewIconButtonProps) => {
  const isActive = useMemo(() => currentViewType === viewType, [viewType, currentViewType]);
  const Icon = useMemo(() => viewTypeIcons[viewType], [viewType]);

  const handleOnViewTypeChange = useCallback(() => {
    if (currentViewType !== viewType) {
      onViewTypeChange(viewType);
    }
  }, [currentViewType, viewType, onViewTypeChange]);

  return (
    <IconButton onClick={handleOnViewTypeChange} size="small" data-test={`${viewType}-button`}>
      <Icon sx={isActive ? { color: 'primary.main' } : undefined} data-test={`${viewType}-icon`} />
    </IconButton>
  );
};
